import moment from "moment";
import $ from "jquery";
import "./daterangepicker.min.js"

import './picker.css';

/*window.sessionStorage.removeItem("start");
window.sessionStorage.removeItem("end");
window.sessionStorage.removeItem("selectedRange");*/

function getSavedMoment(key, defaultValue) {
    const v = window.sessionStorage.getItem(key);
    return v ? moment(v) : defaultValue;
}

function getSavedString(key, defaultValue) {
    const v = window.sessionStorage.getItem(key);
    return v ? v : defaultValue;
}

const ranges = {
    '24 Hours': [moment().startOf('hour').subtract(24, 'hours'), moment().endOf('hour')],
    '48 Hours': [moment().startOf('hour').subtract(48, 'hours'), moment().endOf('hour')],
    'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
    'Last 7 Days': [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')],
    'Last 30 Days': [moment().subtract(29, 'days').startOf('day'), moment().endOf('day')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
}

let selected_start = null;
let selected_end = null;
let selected_unit = "day";
let timeseries_granularity = "day";

function create(el, cb) {
    const selectedRange = getSavedString("selectedRange", 'Last 30 Days');
    let start = null;
    let end = null;

    // selected ranges should automatically update the day when it rolls over
    if (selectedRange in ranges) {
        start = ranges[selectedRange][0];
        end = ranges[selectedRange][1];
    } else {
        // custom date ranges should not change when the day rolls over
        start = getSavedMoment("start", moment().startOf('day').subtract(30, 'days'));
        end = getSavedMoment("end", moment().endOf('day'));
    }


    function updateDom(start, end, selecteRange) {
        window.sessionStorage.setItem("start", start.format());
        window.sessionStorage.setItem("end", end.format());
        window.sessionStorage.setItem("selectedRange", selecteRange);


        selected_start = start;
        selected_end = end;

        // determine if timeseries queries should be by day or by hour
        let daysDifference = selected_end.diff(selected_start, 'days')
        timeseries_granularity = daysDifference > 2 ? "day" : "hour";


        let text = start.format('MMM D, YYYY') + ' - ' + end.format('MMM D, YYYY');
        if (selecteRange === "24 Hours") {
            text = "24 Hours";
            selected_unit = "hour";
        } else if (selecteRange === "48 Hours") {
            text = "48 Hours";
            selected_unit = "hour";
        } else {
            selected_unit = "day";
        }

        $(el).find("span").html(text);
    }

    updateDom(start, end, selectedRange);

    let datePicker = $(el).daterangepicker({
        timePicker: true,
        startDate: start,
        endDate: end,
        alwaysShowCalendars: true,
        opens: "left",
        ranges: ranges
    }, function(start, end, newSelectedRange) {
        updateDom(start, end, newSelectedRange);
        cb(start, end, newSelectedRange);
    });

    // add 'dateChange' event listener
    /*datePicker.on('changeDate', function(e) {
        let p = datePicker.data("daterangepicker");
        updateDom(p.startDate, p.endDate);
    })*/

    return datePicker;
}


const Picker = {
    "create": function (el, cb) {
        return create(el, cb);
    },
    "start": function() {
        return selected_start;
    },
    "end": function() {
        return selected_end;
    },
    "unit": function () {
        return selected_unit;
    },
    "timeseries_granularity": function () {
        return timeseries_granularity;
    },
    "start_YYYYMMDDHHmmss": function() {
        return selected_start.clone().startOf(selected_unit).format("YYYY-MM-DD HH:mm:ss");
    },
    "end_YYYYMMDDHHmmss": function() {
        return selected_end.clone().endOf(selected_unit).add(moment.duration(1, 'second')).format("YYYY-MM-DD HH:mm:ss");
    },
    "timezone": function () {
        return Intl.DateTimeFormat().resolvedOptions().timeZone||"UTC";
    }
};

export default Picker;

